module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-logo/alg-logo.component.html
// module id = ./src/app/components/atoms/alg-logo/alg-logo.component.html
// module chunks = main